import { render, staticRenderFns } from "./ConformityCategoryList.vue?vue&type=template&id=3e3a79f4&"
import script from "./ConformityCategoryList.vue?vue&type=script&lang=js&"
export * from "./ConformityCategoryList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports